import { LEDGER_SNAPSHOT, } from "@frameworks/web/redux/interfaces/Reports/ILedgerSnapShot";
import { combineReducers } from "redux";
import commonOnePlatFormReducer from "@frameworks/web/redux/reducers/common/commonReducer";
const LedgerSnapShotReducer = (state, action) => {
    switch (action.type) {
        case LEDGER_SNAPSHOT:
            return Object.assign(Object.assign({}, state), { snapShot: action.payload.snapShot });
        default:
            return Object.assign({}, state);
    }
};
export default combineReducers({
    reducersData: LedgerSnapShotReducer,
    commonData: commonOnePlatFormReducer,
});
